<nb-card class="player-selection-dialog">
    <nb-card-header>
        <h6 class="mb-0">Selecionar participante</h6>
    </nb-card-header>

    <nb-card-body>
        <div class="selected-player-preview" *ngIf="selectedPlayer">
            <p class="mb-3 paragraph">Participante selecionado:</p>
            <nb-card class="player-header-card">
                <nb-card-body class="p-2">
                    <div class="d-flex align-items-center">
                        <div class="player-avatar-section">
                            <img
                                [src]="selectedPlayer.avatar"
                                [alt]="selectedPlayer.nome_abreviado"
                                class="selected-player-avatar"
                                width="42"
                                height="42"
                            />
                        </div>

                        <div class="player-info-section ml-4">
                            <h4 class="player-name mb-1">{{ selectedPlayer.nome_abreviado }}</h4>
                            <div class="player-details">
                                <div class="player-age">{{ selectedPlayer.idade }} anos</div>
                                <div class="player-location">
                                    {{ selectedPlayer.nome_cidade }}, {{ selectedPlayer.sigla_uf }}
                                </div>
                            </div>
                        </div>
                    </div>
                </nb-card-body>
            </nb-card>
        </div>

        <div class="form-control-group mb-4">
            <label class="label" for="player-search">Buscar participante</label>
            <div class="position-relative">
                <input
                    nbInput
                    fullWidth
                    id="player-search"
                    placeholder="Digite o nome do participante..."
                    [(ngModel)]="searchTerm"
                    (input)="onSearchChange($event)"
                />
            </div>
        </div>

        <div style="position: relative; min-height: 100px" *ngIf="!filteredPlayers.length">
            <nb-spinner
                *ngIf="isSearching"
                size="small"
                class="search-spinner"
                message="Buscando participantes..."
            ></nb-spinner>
        </div>

        <div class="player-results" *ngIf="searchTerm && filteredPlayers.length > 0">
            <p class="mb-3 paragraph">Resultados da busca:</p>
            <div class="player-list-container">
                <nb-list>
                    <nb-list-item
                        *ngFor="let player of filteredPlayers"
                        class="player-list-item"
                        [class.selected]="selectedPlayer?.id_site === player.id_site"
                        (click)="selectPlayer(player)"
                    >
                        <div class="d-flex align-items-center">
                            <img
                                [src]="player.avatar"
                                [alt]="player.nome_abreviado"
                                class="player-avatar-small mr-3"
                                width="32"
                                height="32"
                            />
                            <div>
                                <p class="paragraph player-name m-0">{{ player.nome_abreviado }}</p>
                                <p class="paragraph player-location text-muted small m-0">
                                    {{ player.nome_cidade }}, {{ player.sigla_uf }}
                                </p>
                            </div>
                        </div>
                    </nb-list-item>
                </nb-list>
            </div>
        </div>

        <div class="no-results" *ngIf="!isSearching && searchTerm && filteredPlayers.length === 0">
            <div class="text-center text-muted py-3">
                <p class="m-0">Nenhum jogador encontrado</p>
            </div>
        </div>
    </nb-card-body>

    <nb-card-footer class="d-flex justify-content-end">
        <button nbButton status="basic" class="mr-2" (click)="close()">Cancelar</button>
        <button nbButton status="primary" [disabled]="!selectedPlayer" (click)="confirm()">Confirmar</button>
    </nb-card-footer>
</nb-card>
